import './dossier-illustration-carte.css';
import '../carto/ol-override.css';
import '../../node_modules/ol/ol.css';
import '../utils/utils.css';

import { Carto } from '../common/carte/carte-config.js';
import { initMapForDossierIllustration } from '../common/carte/carte-util.js';
import { Map, Overlay, View } from 'ol';
import { LayerSwitcherMetierControl } from '../common/carte/layer-switcher-metier-control.js';
import VectorLayer from 'ol/layer/Vector';
import { Vector as VectorSource } from 'ol/source';
import GeoJSON from 'ol/format/GeoJSON.js';
import { fromExtent } from 'ol/geom/Polygon.js';

const ONLY_POINT_GEOJSON = {
  type: 'Feature',
  properties: {},
  geometry: {
    type: 'Point',
    coordinates: [853559.5, 6693479],
  },
};

const ONLY_LINE_GEOJSON = {
  type: 'Feature',
  properties: {},
  geometry: {
    type: 'LineString',
    coordinates: [
      [853563, 6693478],
      [853564, 6693480],
    ],
  },
};

const ONLY_POLYGON_GEOJSON = {
  type: 'Feature',
  properties: {},
  geometry: {
    type: 'Polygon',
    coordinates: [
      [
        [853565.5, 6693478],
        [853565.5, 6693480],
        [853567.5, 6693481],
        [853567.5, 6693477],
        [853565.5, 6693478],
      ],
    ],
  },
};

const headerEl = document.querySelector('#header');
const mapEl = document.querySelector('#carte');
const legendeTemplate = document.querySelector('#couche-legende-template');
const legendesEl = document.querySelector('.legende-items');
const asideEl = document.querySelector('.notice-legende-wrapper');
const popupContainer = document.querySelector('#popup');
const popupContent = document.querySelector('#popup-content');
const popupCloser = document.querySelector('#popup-closer');

const toggleFermerButton = document.querySelector(
  '.carte-toggle-bouton.fermer',
);
const toggleOuvrirButton = document.querySelector(
  '.carte-toggle-bouton.ouvrir',
);

let map;
let overlay;
/* Panneau de filtre/résultats */
function toggleAside() {
  asideEl.classList.toggle('notice-legende-wrapper-ouvert');
}
toggleOuvrirButton.addEventListener('click', toggleAside);
toggleFermerButton.addEventListener('click', toggleAside);

function fitCarte() {
  mapEl.style.height = window.innerHeight - headerEl.clientHeight + 'px';
}
window.addEventListener('load', function () {
  fitCarte();
  map = initMapForDossierIllustration('carte', {
    onFeatureClicked,
    controls: {
      autourDeMoi: !!navigator.geolocation,
    },
  });
  initLegende();
  doOverlay();
  map.addControl(new LayerSwitcherMetierControl());
});

// On s'assure que la carte soit ok si on redimmensionne la viewport avec par exemple le passage du mode portrait au mode paysage sur un smartphone
window.addEventListener('resize', () => map?.updateSize());

function doOverlay() {
  overlay = new Overlay({
    element: popupContainer,
    autoPan: true,
    autoPanAnimation: {
      duration: 250,
    },
  });
  map.addOverlay(overlay);
  overlay.setPosition(undefined);
}

popupCloser.addEventListener('click', () => {
  overlay.setPosition(undefined);
  popupCloser.blur();
  return false;
});

function onFeatureClicked(feature) {
  const props = feature.getProperties();
  let keys = Object.keys(props);
  keys.splice(keys.indexOf('geometry'), 1);
  keys.splice(keys.indexOf('link'), 1);
  keys.splice(keys.indexOf('urlImg'), 1);
  keys.splice(keys.indexOf('title'), 1);
  popupContent.innerHTML =
    `<div class="popup-titre"><a href="${props.link}">${props.title}</a></div>` +
    keys
      .filter((key) => key !== 'typeDossier')
      .map(
        (key) =>
          `<div class="popup-row"><span class="cle">${key}</span><span class="valeur">${props[key]}</span></div>`,
      )
      .join('');
  const extent = feature.getGeometry().getExtent();
  overlay.setPosition([
    (extent[0] + extent[2]) / 2,
    (extent[1] + extent[3]) / 2,
  ]);
}

function onStyleSelected(el, layer, e) {
  const coucheLegendeEl = el.querySelector('.couche-legende');
  const style = Carto.styles.find((s) => s.id === e.target.value);
  handleStyle(layer, coucheLegendeEl, style);
}

function handleStyle(layer, coucheLegendeEl, style) {
  if (!style) {
    const defaultStyle = layer.get('defaultStyle');
    layer.setStyle(defaultStyle);
    generateLegendForDefaultStyle(coucheLegendeEl, defaultStyle, layer);
    return;
  }
  layer.setStyle(style.olStyle);
  generateLegendForStyle(coucheLegendeEl, style, layer);
}

function checkCountForLayer(layer, element) {
  if (!layer.getSource().getFeatures().length) {
    element.style.display = 'none';
  } else {
    element.style.display = '';
  }
}

function checkCountForRegle(layer, regle, element) {
  if (!regle.countPositiveElements(layer.getSource().getFeatures())) {
    element.style.display = 'none';
  } else {
    element.style.display = '';
  }
}

function initLegende() {
  map
    .getLayers()
    .getArray()
    .filter(
      (layer) => layer.get('estCoucheMetier') && layer instanceof VectorLayer,
    )
    .forEach((layer) => {
      const container = generateStyleSelector(layer);

      checkCountForLayer(layer, container);

      if (
        layer instanceof VectorLayer &&
        layer.getSource() instanceof VectorSource
      ) {
        layer.getSource().on('featuresloadend', () => {
          checkCountForLayer(layer, container);
        });
      }
    });
}

function generateStyleSelector(layer) {
  const el = legendeTemplate.content.firstElementChild.cloneNode(true);

  el.querySelector('.titre-couche').innerText =
    layer.get('titre') || 'Sans Titre';

  const select = el.querySelector('select');
  const styleId = layer.get('currentStyleId');
  const styleIds = layer.get('stylesId') || [];
  styleIds.forEach((id) => {
    const style = Carto.styles.find((s) => s.id === id);
    const option = document.createElement('option');
    option.value = id;
    option.innerText = style?.titre || 'Sans titre';
    option.selected = styleId === id;
    select.appendChild(option);
  });
  select.addEventListener('change', onStyleSelected.bind(null, el, layer));

  legendesEl.append(el);

  const currentStyle = Carto.styles.find(
    (s) => s.id === layer.get('currentStyleId'),
  );
  handleStyle(layer, el.querySelector('.couche-legende'), currentStyle);

  return el;
}

function generateLegendForStyle(coucheLegendeEl, style, layer) {
  const wrapper = document.createElement('div');
  wrapper.classList.add('style');

  style.regles.forEach((regle) => {
    const regleEl = generateLegendForRegle(regle, layer);
    wrapper.appendChild(regleEl);
  });

  coucheLegendeEl.replaceChildren(wrapper);
}

function generateCountLabel(regle, layer) {
  const count = regle.countPositiveElements(layer.getSource().getFeatures());
  const type = layer.get('typeRecherche');
  if (type === 'Dossier') {
    if (count > 1) {
      return `${count} dossiers`;
    } else {
      return `${count} dossier`;
    }
  } else if (type === 'Illustration') {
    if (count > 1) {
      return `${count} illustrations`;
    } else {
      return `${count} illustration`;
    }
  }
  return '';
}

function generateLegendForRegle(regle, layer) {
  const regleEl = document.createElement('div');
  const symboleEl = document.createElement('span');
  const nomEl = document.createElement('span');

  regleEl.classList.add('regle');
  symboleEl.classList.add('symbole-legende');
  nomEl.innerHTML = `${
    regle.titre
  } <span class="legende-count">${generateCountLabel(regle, layer)}</span>`;
  checkCountForRegle(layer, regle, regleEl);
  nomEl.classList.add('nom-regle');

  layer.getSource().on('featuresloadend', () => {
    nomEl.innerHTML = `${
      regle.titre
    } <span class="legende-count">${generateCountLabel(regle, layer)}</span>`;
    checkCountForRegle(layer, regle, regleEl);
  });

  regleEl.appendChild(symboleEl);
  regleEl.appendChild(nomEl);

  if (regle.miniature && !regle.barycentre) {
    symboleEl.innerHTML = document.getElementById(
      'miniature-icon-template',
    ).innerHTML;
  } else if (regle.iconeId && !regle.barycentre) {
    symboleEl.innerHTML = `
      <img src="/pictos/index/${regle.iconeId}" alt="" class="icone" />
    `;
  } else {
    buildLegendeMap(symboleEl, regle.olStyleForLegende, ONLY_POINT_GEOJSON);
    if (!regle.barycentre) {
      buildLegendeMap(symboleEl, regle.olStyleForLegende, ONLY_LINE_GEOJSON);
      buildLegendeMap(symboleEl, regle.olStyleForLegende, ONLY_POLYGON_GEOJSON);
    }
  }

  return regleEl;
}

function generateLegendForDefaultStyle(coucheLegendeEl, defaultStyle, layer) {
  const wrapper = document.createElement('div');

  const regleEl = document.createElement('div');
  const symboleEl = document.createElement('span');
  const nomEl = document.createElement('span');

  regleEl.classList.add('regle');
  symboleEl.classList.add('symbole-legende');
  nomEl.innerHTML = 'Style par défaut';
  checkCountForLayer(layer, regleEl);
  nomEl.classList.add('nom-regle');

  layer.getSource().on('featuresloadend', () => {
    checkCountForLayer(layer, regleEl);
  });

  regleEl.appendChild(symboleEl);
  regleEl.appendChild(nomEl);

  buildLegendeMap(symboleEl, defaultStyle, ONLY_POINT_GEOJSON);
  buildLegendeMap(symboleEl, defaultStyle, ONLY_LINE_GEOJSON);
  buildLegendeMap(symboleEl, defaultStyle, ONLY_POLYGON_GEOJSON);

  wrapper.appendChild(regleEl);

  coucheLegendeEl.replaceChildren(wrapper);
}

function buildLegendeMap(container, style, geojson) {
  const target = document.createElement('span');
  target.classList.add('mapContainer');
  container.appendChild(target);

  const source = new VectorSource({
    features: new GeoJSON().readFeatures(geojson),
  });
  const layer = new VectorLayer({
    source,
    style,
  });

  const map = new Map({
    controls: [],
    target,
    layers: [layer],
    view: new View({
      projection: 'EPSG:2154',
    }),
  });

  const geometry = fromExtent(source.getExtent());
  geometry.scale(5);
  map.getView().fit(geometry.getExtent());
}
